import useSWR from "swr";
import RobotsTxtService from "services/RobotsTxtService";

const fetcher = (dlid) => RobotsTxtService.get(dlid).then((res) => res.data);

const useRobotsTxt = (dlid) => {
    const { data, error, isLoading, mutate } = useSWR(
        dlid ? ["robots_txt", dlid] : null,
        () => fetcher(dlid)
    );

    return {
        robotsTxt: data?.content || "",
        error,
        isLoading,
        mutate,
    };
};

export default useRobotsTxt;
